export const educationData = [
    {
        id: 1,
        institution: 'VGI Greater Noida UP',
        course: 'Bachelor of Computer Science',
        startYear: '2022',
        endYear: '2025'
    },
    {
        id: 2,
        institution: 'Government Polytechnic Ghaziabad UP',
        course: 'Diploma in I.T',
        startYear: '2021',
        endYear: '2018'
    },
    {
        id: 3,
        institution: 'Chhatrapati Shivaji Saraswati Vidyamandir B.S.R UP',
        course: 'Intermediate',
        startYear: '2016',
        endYear: '2018'
    },
]